export default "__VITE_ASSET__DR7zhWoC__"